<script>
	module.exports = {
		props: {
			tooltip: {
				default: 'Assignment was not submitted by the due date.'
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	.overdue-icon {
		i {
			color: $c-red;
		}
	}
</style>
<template>
	<button
		class="overdue-icon button -link"
		v-tooltip="tooltip">
		<i
			class="fa-solid fa-circle-exclamation"
			aria-hidden="true"></i>
	</button>
</template>
